import { Link } from "react-router-dom";
import { events } from "@/mocks/events";

export default function StoryFeed() {
  const stories = events.slice(1, 5);

  return (
    <section className="w-full bg-background-50">
      <div className="container-x py-14 md:py-20">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="eyebrow">
              <i className="ri-article-line" aria-hidden="true" />
              走红大事记
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              最近发生的出圈事件
            </h2>
          </div>
          <Link
            to="/shijian"
            className="hidden shrink-0 items-center gap-1.5 font-label text-sm text-primary-600 hover:text-primary-700 sm:inline-flex cursor-pointer"
          >
            查看全部大事记
            <i className="ri-arrow-right-up-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:mt-12 md:grid-cols-2">
          {stories.map((e, i) => (
            <article key={e.id} className="card group p-0 transition-colors hover:border-primary-300">
              <Link to={`/shijian/${e.id}`} className="flex h-full flex-col p-6 cursor-pointer md:p-7">
                <div className="flex items-center gap-3 text-xs text-foreground-600">
                  <span className="inline-flex items-center rounded-sm bg-secondary-100 px-2 py-1 font-label text-secondary-900">
                    {e.categoryLabel}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true" />
                    {e.date}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-primary-600">
                    <i className="ri-fire-line" aria-hidden="true" />
                    {e.heat}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {e.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-700">{e.excerpt}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-sm text-foreground-600">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-user-heart-line text-primary-500" aria-hidden="true" />
                    主角 · {e.person}
                  </span>
                  <span className="font-label text-xs text-primary-600 group-hover:text-primary-700">
                    阅读全记录 <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
                <span className="sr-only">{`第${i + 1}条：${e.title}`}</span>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link to="/shijian" className="btn-ghost cursor-pointer">
            查看全部大事记
            <i className="ri-arrow-right-up-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}